import {Link, Route} from 'react-router-dom';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import {useSelector} from "react-redux";
import {checkPermission} from "./RouteValidator";
import AddPurchase from "../../modules/purchase/AddPurchase";
import ManagePurchase from "../../modules/purchase/ManagePurchase";
import UpdatePurchase from "../../modules/purchase/UpdatePurchase";
import AddPurchaseReturn from "../../modules/purchase/AddPurchaseReturn";
import ManagePurchaseReturn from "../../modules/purchase/ManagePurchaseReturn";
import UpdatePurchaseReturn from "../../modules/purchase/UpdatePurchaseReturn";

const GeneratePurchaseModuleRoutes = () => {
    const company = useSelector((state: any) => state.company);
    const auth = useSelector((state: any) => state.auth);

    const routes: any = [];

    // Purchase
    if (checkPermission(auth, company, '/purchases/add')) {
        routes.push(
            <Route path={'/purchases/add'} element={
                <AuthMiddleware children={<AddPurchase/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/purchases')) {
        routes.push(
            <Route path={'/purchases'} element={
                <AuthMiddleware children={<ManagePurchase/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/purchases/details/id')) {
        routes.push(
            <Route path={'/purchases/details/:id'} element={
                <AuthMiddleware children={<UpdatePurchase/>}/>
            }/>
        );
    }

    // Return
    if (checkPermission(auth, company, '/returns/add')) {
        routes.push(
            <Route path={'/returns/add'} element={
                <AuthMiddleware children={<AddPurchaseReturn/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/returns')) {
        routes.push(
            <Route path={'/returns'} element={
                <AuthMiddleware children={<ManagePurchaseReturn/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/returns/details/id')) {
        routes.push(
            <Route path={'/returns/details/:id'} element={
                <AuthMiddleware children={<UpdatePurchaseReturn/>}/>
            }/>
        );
    }


    return routes;
}

export default GeneratePurchaseModuleRoutes;
